// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title_titleContainer__YacBm {
    background-color: #FFFFFF;
    text-align: left;
    padding: 14px 24px;
    border-radius: 6px;
    font-size: large;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* Cabecera de página alineada a tablas de consulta (fondo plano) */
.title_titleConsultation__kyynv {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 1rem 1.35rem;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.04);
}

.title_titleConsultation__kyynv > div:first-child {
    font-size: 1.25rem;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.02em;
}

.title_titleConsultation__kyynv > div:last-child {
    font-size: 0.95rem;
    color: #475569;
}`, "",{"version":3,"sources":["webpack://./src/components/title/title.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,mEAAmE;AACnE;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,+EAA+E;AACnF;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB","sourcesContent":[".titleContainer {\n    background-color: #FFFFFF;\n    text-align: left;\n    padding: 14px 24px;\n    border-radius: 6px;\n    font-size: large;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* Cabecera de página alineada a tablas de consulta (fondo plano) */\n.titleConsultation {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 1rem 1.35rem;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.04);\n}\n\n.titleConsultation > div:first-child {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #0f172a;\n    letter-spacing: -0.02em;\n}\n\n.titleConsultation > div:last-child {\n    font-size: 0.95rem;\n    color: #475569;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleContainer": `title_titleContainer__YacBm`,
	"titleConsultation": `title_titleConsultation__kyynv`
};
export default ___CSS_LOADER_EXPORT___;
